import React from "react";

import Button from "@/components/ui/Button.jsx";
import { cn } from "@/utils/cn";

export function NotificationActionButton({
  tone = "primary",
  className = "",
  style,
  children,
  ...props
}) {
  const toneStyles =
    tone === "danger"
      ? {
          background: "var(--State-Layers-Critical-Opacity-08,rgba(248,83,58,0.08))",
          color: "var(--Schemes-Critical,#F8533A)",
        }
      : {
          background: "var(--State-Layers-Primary-Opacity-08,rgba(29,79,215,0.08))",
          color: "var(--Schemes-Primary,#1D4FD7)",
        };

  return (
    <Button
      variant="tonal"
      size="lg"
      className={cn("min-h-12 rounded-xl text-label-large shadow-none", className)}
      style={{ ...toneStyles, ...style }}
      {...props}
    >
      {children}
    </Button>
  );
}

export function NotificationTextLinkButton({
  className = "",
  style,
  children,
  ...props
}) {
  return (
    <Button
      variant="link"
      className={cn(
        "h-auto min-h-0 justify-start px-0 py-0 text-label-medium no-underline hover:no-underline shadow-none",
        className,
      )}
      style={{ color: "var(--Schemes-Primary,#1D4FD7)", ...style }}
      {...props}
    >
      {children}
    </Button>
  );
}
